export default {
    "Training Overview": "トレーニング概要",
    "View Past Results": "過去の成績を見る",
    "Start Training": "トレーニング開始",
    "Completed Training Session": "トレーニングセッション完了",
    "Average Score": "平均スコア",
    "Best Achieved Score": "ベスト達成スコア",
    "Last Training Taken On": "最終のトレーニング日",
    "Past Results": "過去の成績",
    "Welcome User": "ようこそ",
    "You’re ready to begin your training session. Once you click 'Start', you’ll dive straight into the full set of 40 practice questions.This will help you get into the flow and focus on mastering the material.": "トレーニングセッションを開始する準備が整いました。「開始」をクリックすると、40問の練習問題が始まります。これにより、集中して取り組み、教材をマスターすることができます。",
    "Good Luck !": "頑張ってください！",
    "Dashboard": "ダッシュボード",
    "Answer Summary": "回答概要",
    "Correct": "正解",
    "Incorrect": "不正解",
    "Submit": "提出",
    "Question": "お問い合わせ",
    "Save Your Progress?": "進捗を保存？",
    "You are about to exit the training session. Would you like to save your progress before leaving? Any unsaved changes will be lost.":"トレーニングセッションを終了しようとしています。終了する前に進捗を保存しますか？ 保存されていない変更は失われます",
    "Exit Without Saving": "保存せずに終了",
    "Save and Exit": "保存か終了",
    "View Training Results": "トレーニングの成績を見る",
    "Date": "日付",
    "Score": "スコア",
    "Result report": "結果レポート",
    "Start":"開始",
    "Welcome":"デモ質問",
    "Next":"次へ",
    "Explanation":"解説",
    "Correct Answer":"正解",
    "Option":"選択肢",
    "Reason":"理由",
    "Translate":"翻訳",
    "Profile":"プロフィール",
    "Logout":"ログアウト",
    "Review User Profile":"ユーザープロフィールの確認",
    "Basic Details":"基本情報",
    "First Name":"名",
    "Last Name":"姓",
    "Language":"言語",
    "Preferred Language":"優先言語",
    "Email":"メール",
    "Email address":"メールアドレス",
    "Please review your user profile to ensure all details, including basic information and mandatory documents are accurate and complete.":"「ユーザープロフィールを確認し、基本情報や必須書類を含め、すべての詳細が正確で完全であることを確認してください。」",
    "Before starting your main practice session,we’ll begin with 2 demo questions. These questions will help you to get familiar with the format and flow of the test.Once you completed the demo, you will move on to the full set of 40 practice questions.":"メインの練習セッションを始める前に、デモ質問を2つ行います。これらの質問は、テストの形式や流れに慣れるためのものです。デモを完了すると、40問の練習問題のセットに進みます。",
    "Error occurred in fetching question":"質問の取得中にエラーが発生しました",
    "Something went wrong":"予期しないエラーが発生しました",
    "userEmail not found":"ユーザーのメールアドレスが見つかりません",
    "Please select an option":"オプションを選択してください",
    "Complete":"終了",
    "Session Time":"セッション時間",
    "Result":"結果",
    "Pass":"合格",
    "Fail":"不合格",
    "Are you sure you want to exit?":"本当に終了しますか？",
    "You are about to exit the training session. Any questions attempted till now, will be lost!":"トレーニングセッションを終了しようとしています。今まで、答えていた質問が失われます。",
    "Exit":"終了",
    "Session time is Up. The result will be considered from all the questions attempted out of 40 questions. please confirm OK":"セッション時間が終了しました。結果は、40問中の回答済みの質問を基に判定されます。よろしいですか？",
    "Current Password":	"現在のパスワード",
    "New Password":	"新しいパスワード",
    "Confirm New Password":	"新しいパスワードを確認",
    "Please reset your password":	"パスワードを再設定してください",
    "Error occurred while Login":"ログイン中にエラーが発生しました",
    "Password reset successfully!":"パスワードのリセットに成功しました！",
    "Update Password":"パスワードを更新する"
}

